import { render, staticRenderFns } from "./EditArtist.vue?vue&type=template&id=4e59453e&"
import script from "./EditArtist.vue?vue&type=script&lang=js&"
export * from "./EditArtist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports